import type { ReactElement, ReactNode } from 'react'

import { i18n } from '@lingui/core'

import { Container } from '@twisto/components/atoms/container'
import { Hidden } from '@twisto/components/atoms/hidden'
import { Layout } from '@twisto/components/atoms/layout'

import { ArticlesSearchInput } from '../articles-search-input'

import * as styles from './category-layout.styles'

type Props = {
  breadcrumbs: ReactElement
  contentNavigation: ReactElement
  children: ReactNode
  rootCategoryId?: number
}

export const CategoryLayout = ({
  breadcrumbs,
  contentNavigation,
  children,
  rootCategoryId,
}: Props) => (
  <main>
    <Layout grayBackground variant="screen">
      <Container fullHeight noPadding css={styles.container} size="wider">
        <div>
          <ArticlesSearchInput
            css={styles.searchInput}
            dropdownClassName={styles.dropdown}
            placeholder={
              /*i18n*/ i18n._('categoryLayout.searchInput.placeholder')
            }
            rootCategoryId={rootCategoryId}
          />
          <Hidden smDown>{contentNavigation}</Hidden>
        </div>
        <section css={styles.content}>
          <div css={styles.breadcrumb}>{breadcrumbs}</div>
          {children}
        </section>
      </Container>
    </Layout>
  </main>
)
